export default {
  selectors: {
    paginationButton: '.pagination-links__button',
  },
};
